import { Helmet } from 'react-helmet';

const PageTitle = ({ title }) => {
	const fullTitle = `${title} | Progressive 2025 Shareholders' Report`;

	return (
		<Helmet>
			<title>{fullTitle}</title>
		</Helmet>
	);
};

export default PageTitle;
